/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// utils
// material
import { Page, Content, InContentMessage } from '@insticator/insticator-ui';
import PageHeader from "material/structure/pageheader/pageheader";
import PageContent from "material/structure/pagecontent/pagecontent";
import SiteFilter from 'material/sitefilter/sitefilter';
import LoadingState from 'material/states/loading/loading';
// content
import GeneralSection from './generalsection/generalsection';
// styles
import injectSheet from "react-jss";
import styles from './moderationconfig_styles';
import { fetchModerationConfig } from 'state/thunks/moderation';
import { Button } from '@insticator/insticator-ui/dist/material';
import { url } from 'utils/urls';


/* ========== ~~~~~~~~~~ MODERATION CONFIG PAGE ~~~~~~~~~~ ========== */
const ModerationConfigPage = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { siteUUID, accountUUID } = useSelector(state => state.session);
  const moderation = useSelector(state => state.moderation);

  const [isLoading,setIsLoading] = useState(false)

  useEffect(() => {
    if(accountUUID && siteUUID) getModerationConfig()
  }, [accountUUID, siteUUID]) 

  const getModerationConfig = useCallback(async()=>{
    const response = await dispatch(fetchModerationConfig({ siteId: siteUUID }))
    setIsLoading(false)
  }, [siteUUID, accountUUID])

  return (
    <Page name={'moderationconfigpage'} klass={`${props.classes.moderationconfigpage}`}>
      <SiteFilter />
      <Content>
        <InContentMessage />
        <PageHeader 
          title={'Moderation'} 
          subtitle={'Configuration'}  
          actionButton={<Button name={'dashboardbtn'} icon={'tasks'} text={'Dashboard'} variant={'system'} handleClick={() => window.open(url.moderationDashboard, '_blank')} />}
        />
        <PageContent>
        { isLoading || moderation.status === 'pending' ?
          <LoadingState />
          :
          <>
            <GeneralSection />
          </>
        }
        </PageContent>
      </Content>
    </Page>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ModerationConfigPage